import React from "react";
import { connect } from 'redux-bundler-react';
import { getLayer } from '../../openlayers-utils/layer-utilities';
import GeoJSON from 'ol/format/GeoJSON';
import {Fill, Stroke, Style, Circle as CircleStyle} from 'ol/style';

const style = {
  'Polygon': new Style({
    fill: new Fill({
      color: 'rgba(67, 246, 249, 0.5)'
    }),
    stroke: new Stroke({
      color: 'rgb(67, 246, 249)',
      width: 1
    })
  }),
  'MultiPolygon': new Style({
    fill: new Fill({
      color: 'rgba(67, 246, 249, 0.5)'
    }),
    stroke: new Stroke({
      color: 'rgb(67, 246, 249)',
      width: 1
    })
  }),
  'LineString': new Style({
    stroke: new Stroke({
      color: 'rgb(67, 246, 249)',
      width: 1
    })
  }),
  'Point': new Style({
    image: new CircleStyle({
      radius: 8,
      stroke: new Stroke({
        color: 'rgb(67, 246, 249)'
      }),
      fill: new Fill({
        color: 'rgba(67, 246, 249, 0.6)'
      })
    })
  })
};

class ResultListItem extends React.Component {
  constructor(props){
    super(props);

    const geometryType = props.feature.geometry.type;

    this.layer = getLayer({
      serviceType: 'LocalVector',
      visible: true,
      geometryType: geometryType,
      style: style[geometryType],
      zIndex: 1000
    });

    const features = (new GeoJSON()).readFeatures(props.feature, {dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'});
    const src = this.layer.getSource();
    src.addFeatures(features);

    this.handleClick = this.handleClick.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.handleMouseOver = this.handleMouseOver.bind(this);
  }

  componentWillUnmount(){
    const { map } = this.props;
    map.removeLayer(this.layer);
  }

  handleClick(){
    const { doOpenIdentifyDetails, feature } = this.props;
    doOpenIdentifyDetails(feature, this.layer)
  };

  handleMouseOver(){
    const { map } = this.props;
    map.addLayer(this.layer);
  }

  handleMouseOut(){
    const { map } = this.props;
    map.removeLayer(this.layer)
  }

  render() {
    const { feature } = this.props;

    const key = Object.keys(feature.properties)[0] || 'No Properties';
    const val = feature.properties[key];

    return (
      <li
        onClick={this.handleClick}
        onMouseOver={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}
        className="list-group-item pointer overflow-ellipsis"
        style={{ margin: "3px", padding: "2px", cursor: "pointer", display:'flex'}}
      >
          <span className="col-sm-4">{key}</span>
          <span className="col-sm-8">{val}</span>
      </li>
    );
  }
}

export default connect(
  'selectMap',
  'doOpenIdentifyDetails',
  ResultListItem
);
